import React from "react";
import * as styles from "./RichTextImage.module.css";
import { kontentImage, PageLink } from "../../../types/index";
import { formatImages } from "../../../lib/images";
import { KontentImageElement } from "../KontentImageElement/KontentImageElement";
import { getMultiChoice } from "../../../lib/multichoice";
import { CustomRichTextElement } from "../CustomRichTextElement/CustomRichTextElement";
import { Link } from "../Link/Link";
import { ArtDirectedImageElement } from "../KontentImageElement/ArtDirectedImageElement";

interface Props extends kontentImage {
  internal: { type: String };
  system?: { id: String; codename: String } | undefined;
  link?: PageLink;
}

export const RichTextImage: React.FC<Props> = (props) => {
  const images = formatImages(props.elements);
  const caption = props.elements?.caption;

  const alignment = getMultiChoice(props.elements?.image_alignment) || "center";
  let classes = "";
  if (alignment === "center" || !alignment) {
    classes += styles.center;
  }
  if (alignment === "left") {
    classes += styles.left;
  }
  if (alignment === "right") {
    classes += styles.right;
  }

  const renderImage = () => {
    if (images?.smallImage?.item?.url) {
      return (
        <ArtDirectedImageElement
          mobileImage={{
            image: images.smallImage.item,
          }}
          desktopImage={{
            image: images.largeImage.item,
          }}
          focalPoint={images.largeImage.focalPoint}
        />
      );
    }

    return (
      <KontentImageElement
        image={images?.largeImage?.item}
        alt={images?.largeImage.alt}
        focalPoint={images?.largeImage?.focalPoint}
        layout="constrained"
      />
    );
  };

  return (
    <div
      className={`${styles.outerContainer} ${classes}`}
      style={
        alignment === "left" || alignment === "right"
          ? { maxWidth: images.largeImage?.item?.width }
          : { width: "100%" }
      }
    >
      <div className={styles.innerContainer}>
        {props.link?.href ? (
          <Link to={props.link.href} target={props.link.target}>
            {renderImage()}
          </Link>
        ) : (
          renderImage()
        )}
        {caption && caption.value !== "<p><br></p>" && (
          <CustomRichTextElement content={caption} />
        )}
      </div>
    </div>
  );
};
